module.exports = __webpack_public_path__ + "img/centerWhite.17bd92f8.svg";